module.exports = __webpack_public_path__ + "img/articleCt-l1-logo.067c0f84.png";